export var THDInputAdornmentStyles = {};
